import React, { useMemo, useState } from 'react';
import { products, categories } from '../mock';
import ProductCard from '../components/ProductCard';
import Seo, { SITE_URL, SITE_NAME } from '../components/Seo';

const Shop = () => {
  const [cat, setCat] = useState('ALL');
  const [sort, setSort] = useState('none');

  const filtered = useMemo(() => {
    // Default: natural alphabetical (A→Z) so e.g. "Melanotan I" comes before "Melanotan II".
    const alpha = (a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
    let list = [...products].sort(alpha);
    if (cat !== 'ALL') list = list.filter(p => p.category.toUpperCase() === cat);
    if (sort === 'price') list = [...list].sort((a, b) => (a.price ?? 999) - (b.price ?? 999));
    if (sort === 'stock') list = [...list].sort((a, b) => b.stock - a.stock);
    return list;
  }, [cat, sort]);

  const listLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Vial Rat Research Catalogue',
    itemListElement: products.map((p, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `${SITE_URL}/products/${p.slug}`,
      name: p.name
    }))
  };

  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo
        title="Research Peptide Catalogue Canada | Vial Rat Research Co."
        description="Browse the Vial Rat Research Co. catalogue of research peptides and laboratory materials, shipped from within Canada."
        canonicalPath="/shop"
        jsonLd={listLd}
      />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">RESEARCH CATALOG</div>
      <h1 className="font-serif-display text-white text-5xl md:text-6xl">Shop the Lab</h1>

      <div className="mt-10 flex flex-wrap gap-3 items-center">
        {categories.map(c => (
          <button key={c} onClick={() => setCat(c)}
            className={`font-mono-label text-[11px] px-4 py-2 rounded border transition-colors ${cat === c ? 'bg-[#ff2fa1] border-[#ff2fa1] text-black' : 'border-white/10 text-neutral-300 hover:border-[#ff2fa1] hover:text-white'}`}>
            {c}
          </button>
        ))}
        <button onClick={() => setSort(sort === 'stock' ? 'none' : 'stock')}
          className={`font-mono-label text-[11px] px-4 py-2 rounded border ${sort === 'stock' ? 'bg-white/10 border-white/40 text-white' : 'border-white/10 text-neutral-300 hover:border-[#ff2fa1]'}`}>
          IN STOCK
        </button>
        <button onClick={() => setSort(sort === 'price' ? 'none' : 'price')}
          className={`font-mono-label text-[11px] px-4 py-2 rounded border ${sort === 'price' ? 'bg-white/10 border-white/40 text-white' : 'border-white/10 text-neutral-300 hover:border-[#ff2fa1]'}`}>
          PRICE ↑
        </button>
      </div>

      <div className="mt-8 font-mono-label text-[11px] text-neutral-500">{filtered.length} SPECIMENS</div>

      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {filtered.map(p => <ProductCard key={p.slug} product={p} />)}
      </div>

      <div className="mt-16 pt-8 border-t border-white/5">
        <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-2">FOR RESEARCH USE ONLY</div>
        <p className="text-neutral-400 text-sm max-w-2xl">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default Shop;
